import styled from 'styled-components';

// This is currently only used to prevent non-native attributes from going to the DOM
export var StyledFormControl = /*#__PURE__*/styled.input.withConfig({
  displayName: "StyledFormControl",
  componentId: "c11n-8-107-0__sc-w61kvv-0"
})([""]);